// Two separate concerns, two separate regexes:
//
// 1. PICKER DEDUPE — only collapses entries that are provably the SAME driver
//    accessed through Dynamsoft's 32→64 thunking bridge. Genuine driver-
//    family variants (WIA, ICA) stay visible to the operator.
const SCANNER_PICKER_DEDUPE_PREFIX = /^Twain64-/i;
//
// 2. CANONICAL NAME — strips every known source prefix so the same physical
//    scanner enumerated through different driver bridges/families resolves to
//    a single Device record. Used for matching against existing Devices and
//    for the `name` we save when registering a new Device, so two operators
//    on different bridges still link to one row.
const SCANNER_CANONICAL_PREFIX = /^(Twain64-|Twain-|WIA2?-|ICA-)/i;

export function normalizeScannerName(displayName: string): string {
  return displayName.replace(SCANNER_CANONICAL_PREFIX, '').trim();
}

export function dedupeScannerDevices<T extends { displayName: string }>(
  devices: T[]
): T[] {
  const seen = new Map<string, T>();
  for (const device of devices) {
    const key = device.displayName
      .replace(SCANNER_PICKER_DEDUPE_PREFIX, '')
      .trim()
      .toLowerCase();
    const existing = seen.get(key);
    if (!existing) {
      seen.set(key, device);
      continue;
    }
    // Prefer the entry without the bridge prefix so the canonical name shows
    // in pickers; the thunking duplicate is dropped.
    if (
      SCANNER_PICKER_DEDUPE_PREFIX.test(existing.displayName) &&
      !SCANNER_PICKER_DEDUPE_PREFIX.test(device.displayName)
    ) {
      seen.set(key, device);
    }
  }
  return Array.from(seen.values());
}
